// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "3a2bc2b96c9be426b132" + "/js/" + chunkId + ".js";
};